import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBM4v-CxMI6qkdEVMwKUFCVkTyMaCpfTwI",
  authDomain: "disny-3bbdd.firebaseapp.com",
  projectId: "disny-3bbdd",
  storageBucket: "disny-3bbdd.firebasestorage.app",
  messagingSenderId: "326418672702",
  appId: "1:326418672702:web:a3dc9b40c2efe01d24f56f",
  measurementId: "G-8TRKXZHG53"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider, signInWithPopup };
export default db;